const env = import.meta.env || {}

export const config = Object.freeze({
  supabaseUrl: env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY || '',
  apiBaseUrl: (env.VITE_API_BASE_URL || 'https://api.blazeai.app').replace(/\/$/, ''),
  appBaseUrl: (env.VITE_APP_BASE_URL || globalThis.location?.origin || '').replace(/\/$/, ''),
  enabled: env.VITE_WEB_CANVAS_ENABLED !== '0',
  e2e: env.VITE_E2E_BYPASS_AUTH === '1',
  // Public CDN host for derived asset variants (R2 custom domain). Unset →
  // variants keep using short-lived presigned URLs from the gateway.
  assetCdnBase: (env.VITE_ASSET_CDN_BASE || '').replace(/\/$/, ''),
})

export function configurationError() {
  if (config.e2e) return null
  if (!config.supabaseUrl || !config.supabaseAnonKey) return '缺少 Supabase 配置，请设置 VITE_SUPABASE_URL 和 VITE_SUPABASE_ANON_KEY。'
  return null
}
